import React from "react";
import {
  FiSearch,
  FiGrid,
  FiList,
  FiRotateCcw,
  FiCheckCircle,
  FiUser,
  FiGlobe,
} from "react-icons/fi";
import { PROMOTION_TABS } from "../constants/promotionEndpoints";
import "./PromotionFilterToolbar.css";

const PromotionFilterToolbar = ({
  activeTab,
  onTabChange,
  searchTerm,
  onSearchChange,
  onSearchSubmit,
  selectedType,
  onTypeChange,
  propertyTypes = [],
  selectedState,
  onStateChange,
  states = [],
  selectedCity,
  onCityChange,
  cities = [],
  onResetFilters,
  viewMode,
  onViewModeChange,
  isPartner = false,
  showMyTab = true,
}) => {
  return (
    <div className="promo-filter-toolbar">
      {/* Top row: Module Tabs */}
      <div className="promo-filter-toolbar__tabs">
        <button
          type="button"
          className={`promo-filter-tab ${
            activeTab === PROMOTION_TABS.ALL ? "promo-filter-tab--active" : ""
          }`}
          onClick={() => onTabChange(PROMOTION_TABS.ALL)}
        >
          <FiGlobe className="promo-filter-tab__icon" />
          <span>All Promotions</span>
        </button>

        <button
          type="button"
          className={`promo-filter-tab ${
            activeTab === PROMOTION_TABS.PREFERRED ? "promo-filter-tab--active" : ""
          }`}
          onClick={() => onTabChange(PROMOTION_TABS.PREFERRED)}
        >
          <FiCheckCircle className="promo-filter-tab__icon" />
          <span>Preferred (Partner)</span>
        </button>

        {showMyTab && (
          <button
            type="button"
            className={`promo-filter-tab ${
              activeTab === PROMOTION_TABS.MY ? "promo-filter-tab--active" : ""
            }`}
            onClick={() => onTabChange(PROMOTION_TABS.MY)}
          >
            <FiUser className="promo-filter-tab__icon" />
            <span>My Promotions</span>
          </button>
        )}
      </div>

      {/* Bottom row: Search + Select Dropdowns + View Switcher */}
      <div className="promo-filter-toolbar__controls">
        {/* Search input form */}
        <form
          className="promo-filter-toolbar__search"
          onSubmit={(e) => {
            e.preventDefault();
            if (onSearchSubmit) onSearchSubmit();
          }}
        >
          <FiSearch className="promo-filter-toolbar__search-icon" />
          <input
            type="text"
            placeholder="Search promotion, city, locality..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="promo-filter-toolbar__search-input"
          />
          {searchTerm && (
            <button
              type="button"
              className="promo-filter-toolbar__clear-btn"
              onClick={() => onSearchChange("")}
            >
              ×
            </button>
          )}
        </form>

        {/* Filters Group */}
        <div className="promo-filter-toolbar__selects">
          {/* Property Type */}
          <div className="promo-filter-select-wrap">
            <select
              value={selectedType}
              onChange={(e) => onTypeChange(e.target.value)}
              className="promo-filter-select"
            >
              <option value="">All Property Types</option>
              {propertyTypes.map((t) => {
                const name = typeof t === "object" ? t.name : t;
                const id = typeof t === "object" ? t.id || t.name : t;
                return (
                  <option key={id} value={name}>
                    {name}
                  </option>
                );
              })}
            </select>
          </div>

          {/* State */}
          <div className="promo-filter-select-wrap">
            <select
              value={selectedState}
              onChange={(e) => onStateChange(e.target.value)}
              className="promo-filter-select"
            >
              <option value="">All States</option>
              {states.map((s) => {
                const name = typeof s === "object" ? s.name : s;
                const id = typeof s === "object" ? s.id || s.name : s;
                return (
                  <option key={id} value={name}>
                    {name}
                  </option>
                );
              })}
            </select>
          </div>

          {/* City */}
          <div className="promo-filter-select-wrap">
            <select
              value={selectedCity}
              onChange={(e) => onCityChange(e.target.value)}
              className="promo-filter-select"
            >
              <option value="">All Cities</option>
              {cities.map((c) => {
                const name = typeof c === "object" ? c.name : c;
                const id = typeof c === "object" ? c.id || c.name : c;
                return (
                  <option key={id} value={name}>
                    {name}
                  </option>
                );
              })}
            </select>
          </div>

          {/* Reset button */}
          {(searchTerm || selectedType || selectedState || selectedCity) && (
            <button
              type="button"
              className="promo-filter-reset-btn"
              onClick={onResetFilters}
              title="Reset Filters"
            >
              <FiRotateCcw size={14} />
              <span>Reset</span>
            </button>
          )}
        </div>

        {/* View mode toggle */}
        <div className="promo-view-toggle">
          <button
            type="button"
            className={`promo-view-toggle__btn ${
              viewMode === "grid" ? "promo-view-toggle__btn--active" : ""
            }`}
            onClick={() => onViewModeChange("grid")}
            title="Grid View"
          >
            <FiGrid size={16} />
          </button>
          <button
            type="button"
            className={`promo-view-toggle__btn ${
              viewMode === "table" ? "promo-view-toggle__btn--active" : ""
            }`}
            onClick={() => onViewModeChange("table")}
            title="List / Table View"
          >
            <FiList size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromotionFilterToolbar;
